import React from 'react'
import DefaultEntityConsult from 'components/form/DefaultEntityConsult'
import Safra from 'entity/Safra'

export default function SafraConsulta() {
    return (
        <DefaultEntityConsult
            EntityClass={Safra}
            initialFilters={{ status: "ATIVO" }}
            titulo="Safras"
            routeForm="_safra"
            showEdit={true}
            showDelete={true}
        />
    )
}
